import React from 'react';
import { Phone } from 'lucide-react';
export function Footer() {
  return <footer className="bg-brand-navy text-white pt-16 pb-8 md:pb-8 pb-24" data-id="element-24">
      <div className="container mx-auto px-4" data-id="element-25">
        <div className="flex flex-col items-center text-center max-w-2xl mx-auto mb-12" data-id="element-26">
          <span className="font-heading font-bold text-3xl md:text-4xl text-white mb-6" data-id="element-27">
            ComfyCleanCo
          </span>
          <p className="text-brand-green font-semibold tracking-widest uppercase text-sm mb-8" data-id="element-28">
            Clean · Fresh · Reliable
          </p>

          <a href="tel:9159795151" className="inline-flex items-center justify-center px-8 py-4 rounded-full bg-white/10 hover:bg-white/20 transition-colors text-2xl font-bold mb-10" data-id="element-29">
            <Phone className="w-6 h-6 mr-3 text-brand-green" data-id="element-30" />
            (915) 979-5151
          </a>

          <nav className="flex flex-wrap justify-center gap-x-8 gap-y-4 mb-10" data-id="element-31">
            <a href="#" className="text-white/80 hover:text-white font-medium transition-colors" data-id="element-32">
              Home
            </a>
            <a href="#services" className="text-white/80 hover:text-white font-medium transition-colors" data-id="element-33">
              Services
            </a>
            <a href="#about" className="text-white/80 hover:text-white font-medium transition-colors" data-id="element-34">
              About
            </a>
            <a href="#contact" className="text-white/80 hover:text-white font-medium transition-colors" data-id="element-35">
              Contact
            </a>
          </nav>

          <div className="text-white/60 text-sm mb-12" data-id="element-36">
            <p className="mb-2 font-medium text-white/80" data-id="element-37">Serving:</p>
            <p data-id="element-38">Far East El Paso | Horizon City | Socorro | Clint | Fabens</p>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8 flex flex-col items-center text-center" data-id="element-39">
          <p className="text-white/50 text-sm mb-4" data-id="element-40">
            © 2025 Comfy Clean Co. All rights reserved.
          </p>
          <p className="text-white/30 text-xs" data-id="element-41">Managed by LetLois</p>
        </div>
      </div>
    </footer>;
}